import TripProfileAPI from './tripprofile.api.service'
import LocationsAPI from './location.api.service'
import LodgeAPI from './lodge.api.service'
import ExpenseReportAPI from './expenseReport.api.service'
import MealsAPI from './meals.api.service'
import ReportsAPI from './reports.api.service'
import CommentsAPI from './comments.api.service'
import SnapShotAPI from './snapshot.api.service'
import MiscReportAPI from './miscreport.api.service'
import ProjectsApiService from './projects.api.service'
import UsersApiService from './users.api.service'
import AirfareApiService from './airfare.api.service'
import CarRentalApiService from './carRental.api.service'
import MiscCostsApiService from './miscCosts.api.service'
import GroundTransportationService from './groundTransportation.api.service'

const APIS = {
    tripprofile: TripProfileAPI,
    locations: LocationsAPI,
    lodge: LodgeAPI,
    expenseReport: ExpenseReportAPI,
    meals: MealsAPI,
    reports: ReportsAPI,
    comments: CommentsAPI,
    snapshots: SnapShotAPI,
    miscreports: MiscReportAPI,
    projects: ProjectsApiService,
    users: UsersApiService,
    airfare: AirfareApiService,
    carRental: CarRentalApiService,
    miscCost: MiscCostsApiService,
    groundTransportation: GroundTransportationService
}
export const APIFactory = {
    get: name => APIS[name]
};